<p-toast [style]="{marginTop: '80px'}"></p-toast>
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<!--This is the list at http://localhost:4201/features-->

<div class="features-list">

  <p-table #pt [value]="features" [lazy]="true" (onLazyLoad)="loadLazy($event)" dataKey="featureId"
    selectionMode="single" [(selection)]="feature" (onRowSelect)="onRowSelect($event)"
    [loading]="loading" [paginator]="true" [rows]="1500" [rowsPerPageOptions]="[1500,2000]" showCurrentPageReport="true"
    currentPageReportTemplate="{totalRecords} results. Page {currentPage} of {totalPages}" [totalRecords]="recordTotal"
    sortMode="multiple" [multiSortMeta]="multiSortMeta" styleClass="p-datatable-striped" [ngStyle]="{'width': 'auto'}"
    [resizableColumns]="true" [autoLayout]="true" [responsive]="true">

    <ng-template pTemplate="caption">
      <div class="d-block text-end justify-content-between align-items-center">
        <!--add new-->
        @if (featuresObjList.length > 0) {
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;float: left;margin: 6px;"
          (click)="addToPropertyFeatureTemplate()">Add to Template</button>
        }
        <h1 style="float: left;margin: 6px;">Features</h1>
        <span>
          <!--clear filters-->
          <button pButton pRipple class="p-button-text"
            style="font-size: 80%; padding: 0.643rem 0.75rem !important; margin-right:10px;"
          (click)="reloadPage()">Clear Filters</button>

          <!--add new-->
          <button pButton pRipple class="p-button" style="padding: 0.643rem 0.75rem !important;"
          (click)="onOpenFormAdd()">New Feature +</button>
        </span>
      </div>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [ngStyle]="{'width': 'auto'}">
            {{col.header}}
            <p-sortIcon [field]="col.field"></p-sortIcon>
          </th>
        }
      </tr>
      <tr>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureName', 'in')"></th>
        <!--<th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.shortTermRentalId', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'shortTermRentalVO.propertyCode', 'in')"></th>-->
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'title', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'description', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'name', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'type', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'value', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'quantity', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureType', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'featureLabel', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'defaultFeature', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'defaultHighlight', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'describesType', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'privateNotes', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'distance', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'distanceUnit', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'kbmMap', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'vrboMap', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'rentalsUnitedMap', 'in')"></th>

        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'airbnbCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'bookingcomCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'expediaCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'googleCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'marriottCode', 'in')"></th>
        <th [ngStyle]="{'width': 'auto'}"><input [style]="{'width':'50px','min-width':'90%'}" pInputText type="text" (input)="pt.filter($event.target.value, 'vrboCode', 'in')"></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-feature>
      <tr>
        <td><p-checkbox (click)="addIntoCheckedList(feature)" [binary]="true"></p-checkbox> </td>
        <td><span style="float:none">
          <a>
            <mat-icon style="color:blue; font-size:110%; padding-right:20px;"
            (click)="onOpenFormEdit(feature)">edit</mat-icon>
          </a>
        </span>
      </td>
      <td>{{feature.featureId}} </td>
      <td>{{feature.featureName}} </td>
      <!--<td>{{feature.shortTermRentalId}} </td>
      <td>{{feature.propertyCode}}</td>-->
      <td>{{feature.title}}</td>
      <td>{{feature.description}}</td>
      <td>{{feature.name}}</td>
      <td>{{feature.type}}</td>
      <td>{{feature.value}}</td>
      <td>{{feature.quantity}}</td>
      <td>{{feature.featureType}}</td>
      <td>{{feature.featureLabel}}</td>
      <td>{{feature.defaultFeature}}</td>
      <td>{{feature.defaultHighlight}}</td>
      <td>{{feature.describesType}}</td>
      <td>{{feature.privateNotes}}</td>
      <td>{{feature.distance}}</td>
      <td>{{feature.distanceUnit}}</td>
      <td>{{feature.kbmMap}}</td>
      <td>{{feature.vrboMap}}</td>
      <td>{{feature.rentalsUnitedMap}}</td>
      <td>{{feature.airbnbCode}}</td>
      <td>{{feature.bookingcomCode}}</td>
      <td>{{feature.expediaCode}}</td>
      <td>{{feature.googleCode}}</td>
      <td>{{feature.marriottCode}}</td>
      <td>{{feature.vrboCode}}</td>
    </tr>
  </ng-template>
</p-table>

</div>